
if (!customElements.get('azora-order-table')) {
  customElements.define('azora-order-table', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-order-data]').textContent);
      this.mode = 'sample';
      this.quantities = new Map();
      this.sizeIndex = this.data.options.findIndex(n => /^(size|sizes|尺码|尺寸)$/i.test(n.trim()));
      const selected = this.data.variants.find(v => String(v.id) === this.dataset.selected) || this.data.variants[0];
      this.selected = [...selected.options];
      this.activeVariantId = selected.id;
      if (selected.available) this.quantities.set(selected.id, Math.max(1, selected.min));
      this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency});
      this.message = this.querySelector('.azora-order-message');
      const priceArea=this.closest('.product-details')?.querySelector('.azora-price-container');
      if(priceArea&&!priceArea.querySelector('.azora-wholesale-price-note')){
        const note=document.createElement('div');note.className='azora-wholesale-price-note';
        note.style.cssText='display:flex;flex-direction:column;gap:3px;margin:6px 0 2px;color:#5f5f5f;font-size:12px;line-height:1.35';
        const label=document.createElement('span');label.textContent='Wholesale';
        const shipping=document.createElement('span');shipping.textContent='Shipping calculated at checkout.';
        note.append(label,shipping);priceArea.append(note);
      }
      this.buildOptions();
      this.renderRows();
      this.updateTotals();
      this.addEventListener('click', e => {
        const mode = e.target.closest('[data-mode]');
        if (mode) {
          this.mode = mode.dataset.mode;
          if(this.mode==='sample'){
            this.quantities.clear();
            const first=this.visibleVariants().find(v=>v.available);
            if(first)this.quantities.set(first.id,Math.max(1,first.min));
          }else if(this.totals().quantity<2){
            const first=this.visibleVariants().find(v=>v.available);
            if(first)this.quantities.set(first.id,Math.ceil(Math.max(2,first.min)/(first.step||1))*(first.step||1));
          }
          this.renderRows();
          this.querySelectorAll('[data-mode]').forEach(b => b.setAttribute('aria-pressed', String(b === mode)));
          this.updateTotals();
        }
        const option = e.target.closest('[data-option-index]');
        if (option) {
          e.stopPropagation();
          this.selected[Number(option.dataset.optionIndex)] = option.dataset.value;
          this.buildOptions();
          this.renderRows();
          const v = this.visibleVariants()[0];
          if (v) {
            this.activeVariantId = v.id;
            const area = this.closest('quick-add-dialog, .shopify-section');
            const mediaVariant = this.visibleVariants().find(item => item.media);
            if (mediaVariant) area?.querySelector('media-gallery slideshow-component')?.select?.({id:String(mediaVariant.media)}, undefined, {animate:false});
            area?.querySelectorAll('[data-azora-sku]').forEach(el => el.textContent = v.sku || '—');
          }
          this.updateTotals();
        }
        if (e.target.closest('[data-reset]')) {this.quantities.clear();this.renderRows();this.updateTotals();}
        const stepper=e.target.closest('[data-step]');
        if(stepper){const input=stepper.parentElement.querySelector('input');if(stepper.dataset.step==='1')input.stepUp();else input.stepDown();input.dispatchEvent(new Event('input',{bubbles:true}));}
        if (e.target.closest('[data-add]')) this.addItems();
      });
      this.addEventListener('input', e => {
        if (!e.target.matches('[data-quantity]')) return;
        const input = e.target;
        const id = Number(input.dataset.quantity);
        this.activeVariantId = id;
        const quantity = Number(input.value);
        this.quantities.set(id, Number.isInteger(quantity) && quantity >= 0 ? quantity : 0);
        if(this.totals().quantity>=2){
          this.mode='bulk';
          this.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.mode==='bulk')));
        }
        this.updateTotals();
      });
    }
    visibleVariants() {
      return this.data.variants.filter(v => v.options.every((value,i) => i === this.sizeIndex || value === this.selected[i]));
    }
    buildOptions() {
      const host = this.querySelector('[data-option-controls]');
      host.replaceChildren();
      this.data.options.forEach((name,i) => {
        if (i === this.sizeIndex || (this.data.variants.length === 1 && this.data.variants[0].title === 'Default Title')) return;
        const field = document.createElement('fieldset'); field.className = 'azora-order-option';
        const legend = document.createElement('legend'); legend.textContent = name; field.append(legend);
        const values = document.createElement('div'); values.className = 'azora-order-values';
        [...new Set(this.data.variants.map(v => v.options[i]))].forEach(value => {
          const b = document.createElement('button'); b.type = 'button'; b.textContent = value;
          b.dataset.optionIndex = String(i); b.dataset.value = value; b.setAttribute('aria-pressed',String(value === this.selected[i])); values.append(b);
        });
        field.append(values); host.append(field);
      });
    }
    renderRows() {
      const body = this.querySelector('tbody'); body.replaceChildren();
      this.visibleVariants().forEach(v => {
        const row = document.createElement('tr'); row.dataset.variantId = String(v.id);
        const values = [this.sizeIndex >= 0 ? v.options[this.sizeIndex] : 'One Size',this.currency.format(v.price/100),(v.grams/1000).toFixed(2)+' kg','Stock (999)'];
        values.forEach((text,i) => {const td = document.createElement('td');td.textContent=text;if(i===0)td.style.fontWeight='600';row.append(td);});
        const td = document.createElement('td');const input = document.createElement('input');
        input.type='number';input.min='0';input.step=String(v.step || 1);if(v.max)input.max=String(v.max);
        input.value=String(this.quantities.get(v.id)||0);input.dataset.quantity=String(v.id);
        input.setAttribute('aria-label','Quantity for '+v.title); input.disabled=!v.available;
        if(!v.available)input.title='Currently unavailable';
        const control=document.createElement('div');control.className='azora-order-stepper';
        [-1,1].forEach((step,index)=>{const button=document.createElement('button');button.type='button';button.dataset.step=String(step);button.textContent=step<0?'−':'+';button.setAttribute('aria-label',(step<0?'Decrease ':'Increase ')+v.title);button.disabled=!v.available;if(index===0)control.append(button,input);else control.append(button);});
        td.append(control);row.append(td);body.append(row);
      });
    }
    totals() {
      return this.data.variants.reduce((sum,v) => {
        const q=this.quantities.get(v.id)||0;sum.quantity+=q;sum.grams+=q*v.grams;sum.price+=q*v.price;return sum;
      },{quantity:0,grams:0,price:0});
    }
    updateTotals() {
      const t=this.totals();const discount=t.quantity>=2;
      // Apply the order discount to the subtotal in minor currency units.
      // Rounding each unit first accumulates a different discount for larger quantities.
      const price=discount?t.price-Math.floor(t.price/20):t.price;
      this.querySelector('[data-total-quantity]').textContent=t.quantity;
      
      this.querySelector('[data-total-price]').textContent=this.currency.format(price/100);
      const old=this.querySelector('[data-total-original]');old.hidden=!discount;old.textContent=this.currency.format(t.price/100);
      this.message.textContent=this.mode==='bulk'&&t.quantity<2?'Select at least 2 items for wholesale pricing.':'';
      const activeVariant=this.data.variants.find(v=>v.id===this.activeVariantId)||this.visibleVariants()[0];
      const unitPrice=activeVariant ? (this.mode==='bulk'?(activeVariant.price-Math.floor(activeVariant.price*5/100)):activeVariant.price) : 0;
      const area=this.closest('.product-details');
      area?.querySelectorAll('.azora-price-container[data-azora-main-price="true"]').forEach(el => {
        el.querySelectorAll('.azora-normal-price').forEach(p => p.textContent=this.currency.format(unitPrice/100));
      });
    }
    async addItems() {
      const button=this.querySelector('[data-add]');
      if(button.disabled) return;
      if(![...this.querySelectorAll('[data-quantity]')].every(i=>i.reportValidity()))return;
      const entries=this.data.variants.filter(v=>(this.quantities.get(v.id)||0)>0);
      const t=this.totals();
      if(t.quantity<(this.mode==='bulk'?2:1)){this.message.textContent='Select at least '+(this.mode==='bulk'?2:1)+' item(s).';return;}
      for(const v of entries) {
        const q=this.quantities.get(v.id);
        if(!v.available||q<v.min||(v.max&&q>v.max)||q%(v.step||1)!==0){this.message.textContent='Please check the quantity for '+v.title+'.';return;}
      }
      button.disabled=true;this.message.textContent='Adding items…';
      try {
        const sections=[...new Set([...document.querySelectorAll('cart-items-component')].map(e=>e.dataset.sectionId).filter(Boolean))].slice(0,5);
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:entries.map(v=>({id:v.id,quantity:this.quantities.get(v.id)})),sections:sections.join(','),sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||result.message||'Unable to add items.');
        const cartResponse=await fetch(root+'cart.js');const cart=await cartResponse.json();
        const event=new CustomEvent('cart:update',{bubbles:true,detail:{resource:cart,sourceId:this.dataset.productId,data:{source:'product-form-component',productId:this.dataset.productId,itemCount:t.quantity,sections:result.sections}}});
        this.dispatchEvent(event);this.message.textContent=t.quantity+' item(s) added to cart.';
      }catch(error){this.message.textContent=error.message||'Unable to add items. Please try again.';}
      finally{button.disabled=false;}
    }
  });
}
